import { createContext, useContext, useEffect, useState } from "react";
import { GlobalAlertContext } from "./GlobalAlertContext";
import { api } from "../services/api";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import React from "react";

export const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const navigate = useNavigate();
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);
  const [user, setUser] = useState({});
  const isAuthenticated = !!user;

  useEffect(() => {
    getUser()
    // signOut();
  }, []);

  function signOut() {
    Cookies.remove("projetomodelo.token");
    navigate("/");
  }

  async function getUser() {
    // tentar pegar algo no cookie
    const token = Cookies.get("projetomodelo.token");
    if (token) {
      api
        .get("/auth/session")
        .then(({ data }) => {
          const user = data;
          setUser(user);
        })
        .catch((e) => {
          //Se deu erro deslogamos o user.
          signOut();
        });
      return;
    }
  }

  async function signIn(email, password) {
    handleLoading(true);
    try {
      const { data } = await api({
        method: "post",
        url: "/auth/login",
        data: { email: email.value, password: password.value },
      });

      const { user: userResponse, token } = data.loggedAuth;

      Cookies.set("projetomodelo.token", token, { expires: 7 });

      setUser(userResponse);

      api.defaults.headers["Authorization"] = `Bearer ${token}`;

      handleToast(true, data?.toast, data?.message);

      navigate("/home");
    } catch (err) {
      if (err.response.data?.error === "email") {
        email.error = true;
        email.errorText = err.response.data.message;
      } else if (err.response.data?.error === "password") {
        password.error = true;
        password.errorText = err.response.data.message;
      }
      handleToast(true, err.response.data?.toast, err.response.data?.message);
    }
    handleLoading(false);
    return { email, password };
  }

  return (
    <AuthContext.Provider value={{ signIn, signOut, getUser, isAuthenticated, user }}>
      {children}
    </AuthContext.Provider>
  );
}
